var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.sizes.length > 1,
          expression: "sizes.length > 1"
        }
      ],
      class: _vm.bemBlock,
      attrs: { "data-is-locked": _vm.isLocked }
    },
    _vm._l(_vm.sizes, function(size) {
      return _c(
        "span",
        {
          key: size.id,
          class: [
            _vm.bemElement("container", {
              "no-sale": _vm.isMarketWithoutSale,
              disabled: _vm.isDisabled(size)
            })
          ]
        },
        [
          _c("input", {
            class: _vm.bemElement("size-input"),
            attrs: {
              id: _vm.prefix + size.id,
              type: _vm.multipleSelection ? "checkbox" : "radio",
              name: "product_size",
              "data-attr-url": size.url,
              disabled: _vm.isDisabled(size) && !_vm.isStockAlertEnabled
            },
            domProps: { value: size.value, checked: _vm.isChecked(size) },
            on: {
              change: function($event) {
                return _vm.handleSizeChange($event, size)
              }
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { class: ["size-box", { "is-strike": _vm.isDisabled(size) }] },
            [
              _c(
                "label",
                {
                  class: _vm.bemElement("size-label", {
                    selected: _vm.isChecked(size)
                  }),
                  attrs: { for: _vm.prefix + size.id }
                },
                [
                  _vm.isDisabled(size)
                    ? _c("s", [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.sizeLabel(size)) +
                            "\n        "
                        )
                      ])
                    : [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.sizeLabel(size)) +
                            "\n        "
                        )
                      ],
                  _vm._v(" "),
                  _c("div", { staticClass: "strike" })
                ],
                2
              )
            ]
          ),
          _vm._v(" "),
          _vm.isDisabled(size) && _vm.isStockAlertEnabled
            ? _c(
                "button",
                {
                  class: ["btn", _vm.bemElement("btn-notify-me")],
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.handleSizeChange($event, size)
                    }
                  }
                },
                [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$msg("button.stockalert", "product")))
                  ]),
                  _vm._v(" "),
                  _c("div", { class: _vm.bemElement("icon-notify-me") })
                ]
              )
            : _vm._e()
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }